import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store";
import { mutationBuilder } from "./editSpecification.mutation";

export type State = {
  loading: boolean;
  error: string | null;
  isValid: boolean;
  isDirty: boolean;
  formValues: {
    description: string;
    quantity: number;
    zone: string;
    location: string;
  };
};

const initialState: State = {
  loading: false,
  error: null,
  isValid: true,
  isDirty: false,
  formValues: {
    description: "",
    quantity: 0,
    zone: "",
    location: "",
  },
};

const editSpecificationSlice = createSlice({
  name: "editSpecification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    mutationBuilder(builder);
  },
});

export default editSpecificationSlice.reducer;

export const selectEditSpecificationLoading = (state: RootState) =>
  state.editSpecification.loading;

export const selectEditSpecificationError = (state: RootState) =>
  state.editSpecification.error;